import React from 'react';
import FeatureGrid from '../../components/site/FeatureGrid';
import FaqList from '../../components/site/FaqList';
import HeroSection from '../../components/site/HeroSection';
import SectionTitle from '../../components/site/SectionTitle';
import SiteLink from '../../components/site/SiteLink';
import {useSiteContent} from './siteContent';
import styles from './SitePages.module.css';

const PocPage: React.FC = () => {
    const {heroMetrics, pocPage, primaryCta, secondaryCta} = useSiteContent();

    return (
        <div className={styles.page}>
            <section className={styles.section}>
                <HeroSection
                    description={pocPage.hero.description}
                    eyebrow={pocPage.hero.eyebrow}
                    metrics={heroMetrics}
                    panelDescription={pocPage.hero.panelDescription}
                    panelLabel={pocPage.hero.panelLabel}
                    panelTitle={pocPage.hero.panelTitle}
                    title={pocPage.hero.title}
                />
            </section>

            <section className={styles.section}>
                <SectionTitle
                    description={pocPage.hero.description}
                    eyebrow={pocPage.hero.eyebrow}
                    title={pocPage.hero.panelTitle}
                />
                <div className="site-section"/>
                <div className={styles.compareGrid}>
                    {pocPage.entries.map(entry => (
                        <article className={`site-card ${styles.compareCard}`} key={entry.path}>
                            <span className="site-eyebrow">{entry.title}</span>
                            <h3>{entry.slogan}</h3>
                            <p>{entry.description}</p>
                            <div className={styles.tagBar} style={{marginTop: 18}}>
                                {entry.tags.map(tag => <span className="site-chip" key={tag}>{tag}</span>)}
                            </div>
                            <div className={styles.ctaActions} style={{justifyContent: 'flex-start', marginTop: 18}}>
                                <SiteLink className={styles.ctaGhost} to={entry.path}>{entry.title}</SiteLink>
                            </div>
                        </article>
                    ))}
                </div>
            </section>

            <section className={styles.section}>
                <SectionTitle
                    description={pocPage.faqIntro.description}
                    eyebrow={pocPage.faqIntro.eyebrow}
                    title={pocPage.faqIntro.title}
                />
                <div className="site-section"/>
                <FeatureGrid items={pocPage.features}/>
            </section>

            <section className={styles.section}>
                <div className={styles.faqWrap}>
                    <article className={`site-card ${styles.faqCard}`}>
                        <span className="site-eyebrow">{pocPage.faqIntro.eyebrow}</span>
                        <h3>{pocPage.faqIntro.title}</h3>
                        <p>{pocPage.faqIntro.description}</p>
                    </article>
                    <article className={`site-card ${styles.faqCard}`}>
                        <FaqList items={pocPage.faqItems}/>
                    </article>
                </div>
            </section>
        </div>
    );
};

export default PocPage;
